module.exports = __webpack_public_path__ + "media/images/add-vehicle-c78276ec7b6968731cb1d0c1bac065f9.svg";